import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "save-as-draft__right-side" }

import { ref, computed } from 'vue';
import useBid from '@/composables/useBid';

import { useStore } from 'vuex';
import { IAsset } from '@/types/store';
import { RAW_ASSETS_STATUSES } from '@/constants/statuses';

// #interfaces
interface IProps {
  disabled: boolean;
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewSaveAsDraft',
  props: {
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



// #constants
const { getters, commit } = useStore();
const {
  onUpdateProposal,
  onCreateProposal,
  onUpdateBid,
  isLoading,
  isDraftLoading,
  isProposal,
  proposalId
} = useBid();

// #data
const dialog = ref(false);

// #computed
const asset = computed<IAsset>(() => {
  return getters['getAsset'];
});
const getStatus = computed<string>(() => {
  const { status } = asset.value ?? {};
  return status;
});
const isAuctionCancelled = computed<boolean>(() => {
  return getStatus.value === RAW_ASSETS_STATUSES.CANCELLED;
});
const isAuctionCompleted = computed<boolean>(() => {
  return getStatus.value === RAW_ASSETS_STATUSES.COMPLETED;
});
const isPaused = computed<boolean>(() => {
  // Don't show paused if auction is cancelled or completed
  if (isAuctionCancelled.value || isAuctionCompleted.value) {
    return false;
  }
  const { auction } = asset.value ?? {};
  return !!(auction as any)?.isPaused;
});
const isAuctionInactive = computed<boolean>(() => {
  return isPaused.value || isAuctionCancelled.value || isAuctionCompleted.value;
});
const getPhaseValues = computed<(string | number)[]>(() => {
  return getters['getPhaseValues'];
});

// #methods
const validatePhaseValues = (): boolean => {
  const phaseValues = getPhaseValues.value;

  if (!phaseValues || phaseValues.length === 0) {
    return false;
  }

  // Check if all phase values are greater than 0
  const allValid = phaseValues.every((value) => {
    const numValue = Number(value);
    return numValue > 0 && !isNaN(numValue);
  });

  return allValid;
};

const onSaveAsDraft = async () => {
  // Validate phase values before saving draft
  if (!validatePhaseValues()) {
    commit('errorNotification', {
      text: 'Invalid bid values',
      subtext:
        'All phase amounts must be greater than $0. Please review and update your bid values.',
      closable: true
    });
    return;
  }

  proposalId.value ? onUpdateProposal('draft') : onCreateProposal('draft');
};

const onSubmit = () => {
  // Validate phase values before submission
  if (!validatePhaseValues()) {
    commit('errorNotification', {
      text: 'Invalid bid values',
      subtext:
        'All phase amounts must be greater than $0. Please review and update your bid values.',
      closable: true
    });
    return;
  }

  if (isProposal.value) {
    return proposalId.value ? onUpdateProposal() : onCreateProposal();
  }
  onUpdateBid();
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
    width: "412"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({
        variant: "outlined",
        disabled: _unref(isLoading) || __props.disabled || isAuctionInactive.value,
        loading: _unref(isDraftLoading),
        color: "#18A1C8"
      }, props), {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Save as draft", -1)
        ]))]),
        _: 1
      }, 16, ["disabled", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "save-as-draft__card" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "save-as-draft__title" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Proposal Submission Confirmation ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "save-as-draft__text" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" By clicking \"Submit\", your proposal will become visible to the company requesting the services . Please be aware, action does not finalize your bid. You still maintain the flexibility to modify your proposal up until the deadline of the offer submission phase. ", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" If you choose not to make any changes, the proposal submitted now will be recognized as your starting bid in the auction. ", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" The \"Save as Draft\" button allows you to save your progress without making your proposal visible to the company requesting the services. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "save-as-draft__actions" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "text",
                disabled: _unref(isLoading) || _unref(isDraftLoading),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  disabled: _unref(isLoading) || _unref(isDraftLoading) || isAuctionInactive.value,
                  loading: _unref(isDraftLoading),
                  color: "#18A1C8",
                  onClick: onSaveAsDraft
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Save as draft", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"]),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  disabled: _unref(isLoading) || _unref(isDraftLoading) || isAuctionInactive.value,
                  loading: _unref(isLoading),
                  color: "#18A1C8",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Submit", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})